import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import documentSigner from './translations/documentSigner.json'
import translationEN from './translations/en.json'
import documentStatusEN from './translations/documentStatus/documentStatusEN.json'
import documentStatusDE from './translations/documentStatus/documentStatusDE.json'
import documentStatusDK from './translations/documentStatus/documentStatusDK.json'
import documentStatusNL from './translations/documentStatus/documentStatusNL.json'
import documentStatusFR from './translations/documentStatus/documentStatusFR.json'
import documentStatusHI from './translations/documentStatus/documentStatusHI.json'
import documentStatusIT from './translations/documentStatus/documentStatusIT.json'
import documentStatusPL from './translations/documentStatus/documentStatusPL.json'
import documentStatusPT from './translations/documentStatus/documentStatusPT.json'
import documentStatusRU from './translations/documentStatus/documentStatusRU.json'
import documentStatusES from './translations/documentStatus/documentStatusES.json'
import documentStatusSE from './translations/documentStatus/documentStatusSE.json'
import documentStatusTR from './translations/documentStatus/documentStatusTR.json'

const resources = {
  en: {
    translation: translationEN,
    documentSigner: documentSigner,
    documentStatus: documentStatusEN,
  },
  de: {
    documentStatus: documentStatusDE,
  },
  dk: {
    documentStatus: documentStatusDK,
  },
  nl: {
    documentStatus: documentStatusNL,
  },
  fr: {
    documentStatus: documentStatusFR,
  },
  hi: {
    documentStatus: documentStatusHI,
  },
  it: {
    documentStatus: documentStatusIT,
  },
  pl: {
    documentStatus: documentStatusPL,
  },
  pt: {
    documentStatus: documentStatusPT,
  },
  ru: {
    documentStatus: documentStatusRU,
  },
  es: {
    documentStatus: documentStatusES,
  },
  se: {
    documentStatus: documentStatusSE,
  },
  tr: {
    documentStatus: documentStatusTR,
  },
}

const storedLanguage = localStorage.getItem('i18nextLng') || 'en'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: storedLanguage,
    fallbackLng: 'en',
    preload: ['en'],
    resources,
    debug: false,
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'b', 'u', 'strong', 'i', 'p'],
    },
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'translation',
  })

export default i18n
